<script setup lang="ts">
import type { AlertProps } from '@/types/components/AlertComponent'

defineProps<Partial<AlertProps>>()
defineEmits<{ (e: 'close'): void }>()
</script>

<template>
    <b-notification
        ref="notifRef"
        aria-close-label="Close notification"
        hasIcon
        :type="`is-${type}`"
        :class="`notification`"
        @close="$emit('close')">
        {{ message }}
    </b-notification>
</template>
